/**
 * @description 获取当前时间 默认 ymdhm(年-分钟)
 * @constructor
 */
function getNowTime(str) {
  var d = new Date()
  var year = d.getFullYear()
  var month = d.getMonth() + 1
  month = month < 10 ? '0' + month : month
  var day = d.getDate()
  day = day < 10 ? '0' + day : day
  var hours = d.getHours()
  hours = hours < 10 ? '0' + hours : hours
  var min = d.getMinutes()
  min = min < 10 ? '0' + min : min
  var sec = d.getSeconds()
  sec = sec < 10 ? '0' + sec : sec
  str = str ? str : 'ymdhm'
  switch (
    str // 所需要的区段的首写字母 例如需要 小时+分钟 = 'hm'
  ) {
    case 'ymdhms':
      return (
        year + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec
      )
      break
    case 'ymdhm':
      return year + '-' + month + '-' + day + ' ' + hours + ':' + min
      break
    case 'mdhms':
      return month + '-' + day + ' ' + hours + ':' + min + ':' + sec
      break
    case 'mdhm':
      return month + '-' + day + ' ' + hours + ':' + min
      break
    case 'ymd':
      return year + '-' + month + '-' + day
      break
    case 'hms':
      return hours + ':' + min + ':' + sec
      break
    case 'hm':
      return hours + ':' + min
      break
    default:
      return year + '-' + month + '-' + day + ' ' + hours + ':' + min
      break
  }
}

/**
 * @description 获取当前时间 默认 ymdhm(年-分钟)
 * @constructor
 */
function getTimeFormat(date, str) {
  var d = new Date(date)
  var year = d.getFullYear()
  var month = d.getMonth() + 1
  month = month < 10 ? '0' + month : month
  var day = d.getDate()
  day = day < 10 ? '0' + day : day
  var hours = d.getHours()
  hours = hours < 10 ? '0' + hours : hours
  var min = d.getMinutes()
  min = min < 10 ? '0' + min : min
  var sec = d.getSeconds()
  sec = sec < 10 ? '0' + sec : sec
  str = str ? str : 'ymdhm'
  switch (
    str // 所需要的区段的首写字母 例如需要 小时+分钟 = 'hm'
  ) {
    case 'ymdhms':
      return (
        year + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec
      )
      break
    case 'ymdhm':
      return year + '-' + month + '-' + day + ' ' + hours + ':' + min
      break
    case 'mdhms':
      return month + '-' + day + ' ' + hours + ':' + min + ':' + sec
      break
    case 'mdhm':
      return month + '-' + day + ' ' + hours + ':' + min
      break
    case 'ymd':
      return year + '-' + month + '-' + day
      break
    case 'hms':
      return hours + ':' + min + ':' + sec
      break
    case 'hm':
      return hours + ':' + min
      break
    default:
      return year + '-' + month + '-' + day + ' ' + hours + ':' + min
      break
  }
}
/**
 * @description 获取上报的预约时间
 * @constructor
 */
function getRepairTime(time) {
  function ymdFormat(date) {
    let y = date.getFullYear()
    let m = date.getMonth() + 1
    m = m < 10 ? '0' + m : m
    let d = date.getDate()
    d = d < 10 ? '0' + d : d
    let h = date.getHours()
    h = h < 10 ? '0' + h : h
    return y + '-' + m + '-' + d + 'T' + h + ':00'
  }
  let res = {
    time1: null,
    time2: null
  }
  let d = new Date()
  res.time1 = ymdFormat(d)
  d.setHours(d.getHours() + 2)
  res.time2 = ymdFormat(d)
  return res
}

/**
 * @description 最近时间（支持 小时，天， 周 ，月）
 * @constructor 时间往前减
 */
function getRecentlyTime(num, type) {
  /**
   *
   * @param {*} date 时间
   * @param {*} type 类型（1.开始时间  2.接受时间）
   */
  function ymDayFormat(date, type) {
    let y = date.getFullYear()
    let m = date.getMonth() + 1
    m = m < 10 ? '0' + m : m
    let d = date.getDate()
    d = d < 10 ? '0' + d : d
    switch (type) {
      case 'start':
        return y + '-' + m + '-' + d + ' 00:00:00'
        break
      case 'end':
        return y + '-' + m + '-' + d + ' 23:59:59'
        break
      default:
        return y + '-' + m + '-' + d + ' 00:00:00'
        break
    }
  }

  function ymdFormat(date) {
    let y = date.getFullYear()
    let m = date.getMonth() + 1
    m = m < 10 ? '0' + m : m
    let d = date.getDate()
    d = d < 10 ? '0' + d : d
    let h = date.getHours()
    h = h < 10 ? '0' + h : h
    let min = date.getMinutes()
    min = min < 10 ? '0' + min : min
    let sec = date.getSeconds()
    sec = sec < 10 ? '0' + sec : sec
    return y + '-' + m + '-' + d + ' ' + h + ':' + min + ':' + sec
  }

  let d = new Date()
  let res = {
    time1: null,
    time2: null
  }
  let timeRange = []
  switch (type) {
    case 1:
      res.time2 = ymdFormat(d)
      d.setHours(d.getHours() - num)
      res.time1 = ymdFormat(d)
      break
    case 2:
      console.log('最近三天', num)
      res.time2 = ymdFormat(d)
      d.setHours(d.getHours() - num * 24)
      res.time1 = ymdFormat(d)
      break
    case 3:
      res.time2 = ymDayFormat(d, 'end')
      d.setHours(d.getHours() - num * 7 * 24)
      res.time1 = ymDayFormat(d)
      break
    case 4:
      res.time2 = ymDayFormat(d, 'end')
      d.setMonth(d.getMonth() - num)
      res.time1 = ymDayFormat(d)
      break
  }
  timeRange.push(res.time1)
  timeRange.push(res.time2)
  return timeRange
}

//时间往后加
function getRecentlyTime2(num, type) {
  /**
   *
   * @param {*} date 时间
   * @param {*} type 类型（1.开始时间  2.接受时间）
   */
  function ymDayFormat(date, type) {
    let y = date.getFullYear()
    let m = date.getMonth() + 1
    m = m < 10 ? '0' + m : m
    let d = date.getDate()
    d = d < 10 ? '0' + d : d
    switch (type) {
      case 'start':
        return y + '-' + m + '-' + d + ' 00:00:00'
        break
      case 'end':
        return y + '-' + m + '-' + d + ' 23:59:59'
        break
      default:
        return y + '-' + m + '-' + d + ' 00:00:00'
        break
    }
  }

  function ymdFormat(date) {
    let y = date.getFullYear()
    let m = date.getMonth() + 1
    m = m < 10 ? '0' + m : m
    let d = date.getDate()
    d = d < 10 ? '0' + d : d
    let h = date.getHours()
    h = h < 10 ? '0' + h : h
    let min = date.getMinutes()
    min = min < 10 ? '0' + min : min
    let sec = date.getSeconds()
    sec = sec < 10 ? '0' + sec : sec
    return y + '-' + m + '-' + d + ' ' + h + ':' + min + ':' + sec
  }

  let d = new Date()
  let res = {
    time1: null,
    time2: null
  }
  let timeRange = []
  switch (type) {
    case 1:
      console.log(d)
      res.time1 = ymdFormat(d)
      d.setHours(d.getHours() + Number(num))
      res.time2 = ymdFormat(d)
      break
    case 2:
      console.log('最近三天', num)
      res.time1 = ymdFormat(d)
      d.setHours(d.getHours() + Number(num) * 24)
      res.time2 = ymdFormat(d)
      break
    case 3:
      res.time1 = ymDayFormat(d, 'end')
      d.setHours(d.getHours() + Number(num) * 7 * 24)
      res.time2 = ymDayFormat(d)
      break
    case 4:
      res.time1 = ymDayFormat(d, 'start')
      d.setMonth(d.getMonth() + Number(num))
      res.time2 = ymDayFormat(d)
      break
  }
  timeRange.push(res.time1)
  timeRange.push(res.time2)
  return timeRange
}
//获取今天的日期
function getToday(moreDay) {
  var d = new Date()
  d.setDate(d.getDate() + moreDay)
  var y = d.getFullYear()
  var m = d.getMonth() + 1 //获取当前月份的日期
  if (m < 10) {
    m = '0' + m
  }
  var day = d.getDate()
  if (day < 10) {
    day = '0' + day
  }
  return y + '-' + m + '-' + day
}

/**
 *
 * @param {*} d1
 * @param {*} d2
 */
function timeRange(beginTime, endTime) {
  //如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
  // var dateBegin = new Date(d1.replace(/-/g, "/"));//将-转化为/，使用new Date
  // var dateEnd = new Date(d2.replace(/-/g, "/"));//将-转化为/，使用new Date
  var dateBegin = new Date(beginTime); //将-转化为/，使用new Date
  var dateEnd = new Date(endTime); //将-转化为/，使用new Date
  var dateNow = new Date(); //获取当前时间

  var beginDiff = dateNow.getTime() - dateBegin.getTime(); //时间差的毫秒数
  var beginDayDiff = Math.floor(beginDiff / (1000)); //计算出相差天数

  var endDiff = dateEnd.getTime() - dateNow.getTime(); //时间差的毫秒数
  var endDayDiff = Math.floor(endDiff / (1000)); //计算出相差天数
  if (endDayDiff < 0) { //已过期
    return false
  }
  if (beginDayDiff < 0) { //没到开始时间
    return false;
  }
  return true;
}

function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return time_str
}
/** 
 * date 为2020-01-01T00:00:00.000000Z 这种UTC通用时间格式
 * 转化为 2020-01-01 00:00:00这种日期格式
 */
function parseUTCtime(date) {
  var json_date = new Date(date).toJSON();
  return new Date(new Date(json_date) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
}

export default {
  getNowTime,
  getRepairTime,
  getToday,
  getRecentlyTime,
  getRecentlyTime2,
  timeRange,
  getTimeFormat,
  parseTime,
  parseUTCtime
}